/**
 * Created by vedi on 28/11/15.
 */
function start() {

  const LOGIN_DATA = _.extend({
    'grant_type': 'password'
  });

  $.ajaxSetup({
    headers: {
      'Authorization':
        `Basic ${btoa(window.config.defaultClient.clientId + ':' + window.config.defaultClient.clientSecret)}`
    }
  });

  var auth = (data, errorElement) => {
    "use strict";

    return Promise
      .resolve($.post('/oauth', data))
      .then((data) => {
        errorElement.hide(400);
        var now = new Date();
        now.setDate(now.getDate() + 1); // 1 day
        Cookies.set('access_token', data['access_token'], {expires: now});
        now.setDate(now.getDate() + 29); // 1 month
        Cookies.set('refresh_token', data['refresh_token'], {expires: now});

        window.location.assign('/app/');

      })
      .catch((err) => {
        if (err.status === 423) {
          let url = window.location.pathname == '/sign-up' ?
            `/verification-email-sent?username=${data.username}` :
            `/unvalidated?username=${data.username}`;
          window.location.assign(url);
        }

        errorElement.html('<strong>Error!</strong> Sorry, cannot login with data provided.');
        errorElement.show(400);
        console.log('Error');
        console.log(err);
      });
  };

  var getUrlParameter = (sParam) => {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  };

  $('#login-form').submit((event) => {
    event.preventDefault();

    var formElement = $('#login-form');
    var errorElement = formElement.find('.__error');

    let formData = _.reduce(formElement.serializeArray(), function(result, item) {
      result[item.name] = item.value;
      return result;
    }, {});

    let data = _.extend(formData, LOGIN_DATA);

    auth(data, errorElement);
  });

  $('#forgot-password-form').submit((event) => {
    event.preventDefault();

    var formElement = $('#forgot-password-form');
    var errorElement = formElement.find('.__error');

    let formData = _.reduce(formElement.serializeArray(), function(result, item) {
      result[item.name] = item.value;
      return result;
    }, {});

    Promise
      .resolve($.post('/api/users/forgot', formData))
      .then(() => {
        errorElement.hide(400);

        window.location.assign('/email-sent');
      })
      .catch((err) => {
        if (err.responseJSON && err.responseJSON.message) {
          errorElement.html('<strong>Error!</strong> ' + err.responseJSON.message);
        } else {
          errorElement.html('<strong>Error!</strong> Sorry, cannot restore password with data provided.');
        }
        errorElement.show(400);
        console.log('Error');
        console.log(err);
      });

  });

  $('#restore-password-form').submit((event) => {
    event.preventDefault();

    var formElement = $('#restore-password-form');
    var errorElement = formElement.find('.__error');


    let formData = _.reduce(formElement.serializeArray(), function(result, item) {
      result[item.name] = item.value;
      return result;
    }, {});

    if (formData.newPassword !== formData.verifyPassword) {
      errorElement.html('<strong>Error!</strong> Passwords do not match.');
      errorElement.show(400);
      return;
    }

    let token = getUrlParameter('token');

    Promise
      .resolve($.post('/api/users/reset/' + token, formData))
      .then(() => {
        errorElement.hide(400);

        window.location.assign('/login');
      })
      .catch((err) => {
        if (err.responseJSON && err.responseJSON.message) {
          errorElement.html('<strong>Error!</strong> ' + err.responseJSON.message);
        } else {
          errorElement.html('<strong>Error!</strong> Sorry, cannot change password with data provided.');
        }
        errorElement.show(400);
        console.log('Error');
        console.log(err);
      });

  });

  $('#sign-up-form').submit((event) => {
    event.preventDefault();

    var formElement = $('#sign-up-form');
    var errorElement = formElement.find('.__error');

    let formData = _.reduce(formElement.serializeArray(), function(result, item) {
      result[item.name] = item.value;
      return result;
    }, {});

    if (formData.password !== formData.confirmPassword) {
      errorElement.html('<strong>Error!</strong> Passwords do not match.');
      errorElement.show(400);
      return;
    }
    // default value for share field
    if (formData.mode == config.MODES.PUBLISHER) {
      formData.share = 50;
    }
    delete formData.confirmPassword;

    Promise
      .resolve($.post('/api/users', formData))
      .then((data) => {
        let loginData = _.extend(_.pick(formData, 'username', 'password'), LOGIN_DATA);

        return auth(loginData, errorElement);
      })
      .catch((err) => {
        if (err.status === 400) {
          errorElement.html('<strong>Error!</strong> Sorry, this e-mail is already registered.');
        } else {
          errorElement.html('<strong>Error!</strong> Sorry, cannot sign up.');
        }

        errorElement.show(400);
        console.log('Error');
        console.log(err);
      });
  });
  function selectizeValidationFix($select) {

    let self = $select[0].selectize;

    self.$input.on('invalid', function (event) {
      event.preventDefault();
      self.focus(true);
    });

  }

  if (window.location.pathname == '/sign-up') {
    let selectCountry = $('#select-country');
    $.ajax({
      url: '/api/countries?perPage=300',
      type: 'GET',
      error: function(err) {
        console.log('Error');
        console.log(err);
      },
      success: function(res) {
        let $select = selectCountry.selectize({
          valueField: 'id',
          labelField: 'name',
          searchField: 'name',
          options: res,
          onChange: function(value) {
            selectCountry.val(value);
          }
        });
        selectizeValidationFix($select);
      }
    });
  }

  if (window.location.pathname == '/verification-email-request') {
    let query = decodeURIComponent(window.location.search.substring(1));
    if (query) {
      $('#username').val(query.split('=')[1]);
    }

    $('#verification-request-form').submit((event) => {
      event.preventDefault();

      var formElement = $('#verification-request-form');
      var errorElement = formElement.find('.__error');

      let formData = _.reduce(formElement.serializeArray(), function(result, item) {
        result[item.name] = item.value;
        return result;
      }, {});

      Promise
        .resolve($.post('/api/users/requestVerification', formData))
        .then(() => {
          errorElement.hide(400);

          window.location.assign('/verification-email-sent?username=' + formData.username);
        })
        .catch((err) => {
          if (err.responseJSON && err.responseJSON.message) {
            errorElement.html('<strong>Error!</strong> ' + err.responseJSON.message);
          } else {
            errorElement.html('<strong>Error!</strong> Sorry, cannot resend verification email with data provided.');
          }
          errorElement.show(400);
          console.log('Error');
          console.log(err);
        });
    });
  }
}